import Environment from '@cobliteam/react-environments';
import { type Interaction, OramaClient } from '@oramacloud/client';
import { nanoid } from 'nanoid';
import { useCallback, useEffect, useState } from 'react';
import sidebarDef from '../sidebarDef';
import { type Category, type DataWithCategory, EnumCategory, type OramaIaWithCategory } from '../types';

const env = Environment.getInstance().getEnvironment();

const oramaClient = new OramaClient({
  endpoint: env.oramaSuporteHost,
  api_key: env.oramaSuporteApiKey,
});

export type Nullable<T> = T | null;

const useFetchIAOrama = ({ search }: { search: string }) => {
  const [interactionId, setInteractionId] = useState<string | null>(null);
  const [interaction, setInteraction] = useState<Interaction | null>(null);
  const [results, setResults] = useState<DataWithCategory[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const answerSession = oramaClient.createAnswerSession({
    inferenceType: 'documentation',
    systemPrompts: ['sp_generic-global-search-article-za5rz8', 'sp_html-response-lli0vm'],
    events: {
      // onMessageChange: (messages) => console.log({ messages }),
      // onMessageLoading: (loading) => console.log({ loading }),
      // onAnswerAborted: (aborted) => console.log({ aborted }),
      // onSourceChange: (sources) => console.log({ sources }),
      // onQueryTranslated: (query) => console.log({ query }),
      onStateChange: (state) => {
        if (state.every((interaction) => !interaction.loading)) {
          setInteraction(state[0]);
        }
      },
      onNewInteractionStarted: (interactionId) => setInteractionId(interactionId),
    },
  });

  const fetch = useCallback(async () => {
    if (!search) return;

    try {
      setIsLoading(true);
      const response = await answerSession.ask({
        term: `${search}`,
      });

      if (!results) return;

      const groupCategory = sidebarDef.find((category) => category.categories.find((c) => c.id === EnumCategory.IA_ARTICLES));
      const category: Category | undefined = groupCategory?.categories.find((c) => c.id === EnumCategory.IA_ARTICLES);
      if (!category) return;

      const result: OramaIaWithCategory = {
        id: interactionId || nanoid(),
        content: response,
        query: search,
        category,
        interaction,
      };

      if (result.content.includes("I'm sorry")) {
        setResults([]);
        return;
      }

      setResults([result]);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [search]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { results, isLoading };
};

export default useFetchIAOrama;
